var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundRecommenderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3727",
    "data-name": "Rectangle 3727",
    width: 50,
    height: 60,
    transform: "translate(253 2059)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_578",
    "data-name": "Mask Group 578",
    transform: "translate(-253 -2059)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BPD-icon2-pro-14",
    transform: "translate(253.379 2059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M43.47,16.695a5.943,5.943,0,0,0-1.755-4.224L33.289,4.05A6.4,6.4,0,0,0,31.36,2.743a6.313,6.313,0,0,0-2.56-.558H13.531c-4.142,0-7.5.155-9.92,2.089S.2,9.266,0,15.013V46.245c0,6.368,1.134,9.769,3.913,11.739C6.551,59.858,10.245,60,15.57,60H27.913c5.326,0,9.015-.142,11.657-2.016,2.775-1.97,3.909-5.371,3.909-11.739V16.695",
    fill: "#cbeef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M33.289,4.05A6.336,6.336,0,0,0,31.36,2.743H31.2V5.029c0,4.256.366,7.031,2.24,8.6,1.7,1.422,4.114,1.422,7.771,1.422h2.007A5.943,5.943,0,0,0,41.7,12.494Z",
    fill: "#85d8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M21.733,2.2H13.513c-4.142,0-7.5.155-9.915,2.089S.2,9.266,0,15.013V46.245c0,6.368,1.134,9.769,3.913,11.739a9.888,9.888,0,0,0,4,1.577Z",
    fill: "#89dae4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M36.059,0a9.394,9.394,0,1,0,9.394,9.394A9.394,9.394,0,0,0,36.059,0",
    fill: "#f6911e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M35.557,13.28a1.486,1.486,0,0,1-.315-.037,1.426,1.426,0,0,1-.955-.763L32.457,8.754A1.426,1.426,0,1,1,35.017,7.5l1.051,2.144L46.9,1.115a1.426,1.426,0,1,1,1.765,2.24l-12.229,9.6a1.426,1.426,0,0,1-.882.306",
    fill: "#e2ded6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M35.438,29.9l-.457-4.361v-.064l-.027-.128-.041-.133a.85.85,0,0,0-.046-.114,1.23,1.23,0,0,0-.073-.133.727.727,0,0,0-.059-.1,1.421,1.421,0,0,0-.105-.128l-.078-.05h0l-.142-.114a.457.457,0,0,0-.073-.055,1.371,1.371,0,0,0-.183-.1l-.055-.027a1.568,1.568,0,0,0-.261-.078H33.8a1.778,1.778,0,0,0-.224,0l-4.754-.087h0a1.422,1.422,0,0,0-1.083,2.345h.023a1.413,1.413,0,0,0,.32.274L29.326,27.9l-6.249,6.3-6.318-1.97a1.426,1.426,0,0,0-1.335.265L8.686,38.121a1.428,1.428,0,1,0,1.829,2.194L16.654,35.2l6.4,1.993a1.417,1.417,0,0,0,1.435-.357l7-7.063,1.554,1.312h0a1.431,1.431,0,0,0,.974.389h.155A1.426,1.426,0,0,0,35.438,29.9",
    fill: "#359ebb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundRecommenderIcon);
export default __webpack_public_path__ + "static/media/fund-recommender-icon.93fbd5a04c35619fabdf1083c7b3a714.svg";
export { ForwardRef as ReactComponent };